import React, { useEffect } from "react";
import mixpanel, { Mixpanel } from 'mixpanel-browser';

const MixpanelContext = React.createContext({ mixpanel: Mixpanel });

const MixpanelProvider = ({ children }) => {
  mixpanel.init(process.env.REACT_APP_MIXPANEL_PROJECT, {
    debug: process.env.NODE_ENV === "production" ? false : true,
  });
  

  return (
    <MixpanelContext.Provider value={{ mixpanel }}>
      {children}
    </MixpanelContext.Provider>
  );
};

export { MixpanelContext, MixpanelProvider,mixpanel };
